import React, {useState} from 'react';
import General from "./Forms/General";
import SlidersMenus from "./Forms/SlidersMenus";
import Widgets from "./Forms/Widgets";
import PlusWidgets from "./Forms/PlusWidgets";
import ShopWidgets from "./Forms/ShopWidgets";
import Socials from "./Forms/Socials";
import ContactInfo from "./Forms/ContactInfo";
import Other from "./Forms/Other";
import MobileApp from "./Forms/MobileApp";
import Seo from "./Forms/Seo";
import Banks from "./Forms/Banks";
import NotificationTexts from './Forms/NotificationTexts';

const Generals = (props) => {
   const [activeNav, setActiveNav] = useState('general');
   return (
      <div className="content px-3 py-2">
         <div>
            <div className="nav-headers">
               <ul className="flex">
                  <li id="general" className={`nav-items rounded-t py-2 px-3 ${activeNav == "general" && "active"}`}>
                     <button onClick={() => setActiveNav("general")}>عمومی</button>
                  </li>
                  <li id="seo" className={`nav-items rounded-t py-2 px-3 ${activeNav == "seo" && "active"}`}>
                     <button onClick={() => setActiveNav("seo")}>Seo</button>
                  </li>
                  <li id="slider-menus"
                      className={`nav-items rounded-t py-2 px-3 ${activeNav == "slider-menus" && "active"}`}>
                     <button onClick={() => setActiveNav("slider-menus")}>اسلایدر و منو</button>
                  </li>
                  <li id="widgets" className={`nav-items rounded-t py-2 px-3 ${activeNav == "widgets" && "active"}`}>
                     <button onClick={() => setActiveNav("widgets")}>ویجت ها</button>
                  </li>
                  <li id="plus_widgets" className={`nav-items rounded-t py-2 px-3 ${activeNav == "plus_widgets" && "active"}`}>
                     <button onClick={() => setActiveNav("plus_widgets")}>ویجت ها ی پلاس</button>
                  </li>
                  <li id="shop_widgets" className={`nav-items rounded-t py-2 px-3 ${activeNav == "shop_widgets" && "active"}`}>
                     <button onClick={() => setActiveNav("shop_widgets")}>ویجت ها ی فروشگاه</button>
                  </li>
                  <li id="socials" className={`nav-items rounded-t py-2 px-3 ${activeNav == "socials" && "active"}`}>
                     <button onClick={() => setActiveNav("socials")}>شبکه های اجتماعی</button>
                  </li>
                  <li id="contact-info"
                      className={`nav-items rounded-t py-2 px-3 ${activeNav == "contact-info" && "active"}`}>
                     <button onClick={() => setActiveNav("contact-info")}>اطلاعات تماس</button>
                  </li>
                  <li id="banks" className={`nav-items rounded-t py-2 px-3 ${activeNav == "banks" && "active"}`}>
                     <button onClick={() => setActiveNav("banks")}>درگاه های پرداخت</button>
                  </li>
                  <li id="mobile-app" className={`nav-items rounded-t py-2 px-3 ${activeNav == "mobile-app" && "active"}`}>
                     <button onClick={() => setActiveNav("mobile-app")}>اپلیکیشن</button>
                  </li>
                  <li id="notification-texts" className={`nav-items rounded-t py-2 px-3 ${activeNav == "notification-texts" && "active"}`}>
                     <button onClick={() => setActiveNav("notification-texts")}>متن اعلان ها</button>
                  </li>
                  <li id="other" className={`nav-items rounded-t py-2 px-3 ${activeNav == "other" && "active"}`}>
                     <button onClick={() => setActiveNav("other")}>دیگر</button>
                  </li>
               </ul>
            </div>
            <div className="nav-body">
               {activeNav == "general" && <General/>}
               {activeNav == "seo" && <Seo/>}
               {activeNav == "slider-menus" && <SlidersMenus/>}
               {activeNav == "widgets" && <Widgets/>}
               {activeNav == "plus_widgets" && <PlusWidgets/>}
               {activeNav == "shop_widgets" && <ShopWidgets/>}
               {activeNav == "socials" && <Socials/>}
               {activeNav == "contact-info" && <ContactInfo/>}
               {activeNav == "banks" && <Banks/>}
               {activeNav == "mobile-app" && <MobileApp/>}
               {activeNav == "notification-texts" && <NotificationTexts/>}
               {activeNav == "other" && <Other/>}
            </div>
         </div>
      </div>
   )
};

export default Generals;